import React, { useState, useEffect } from "react";
import "./AboutUsPage.css";
import CarouselAboutUs from "../CarouselAboutUs/CarouselAboutUs";
import Carousel from "../Carousel/Carousel";

const AboutUsPage= (props)=>{
    const [aboutUsTitle,setAboutUsTitle] =useState('');
    const [aboutUsRichText,setAboutUsRichText] =useState('');
    const [aboutUsCarouselItems,setAboutUsCarouselItems] =useState([]);
    const [isMobile, setIsMobile] = useState(true);

    useEffect(()=>{
        if(window.innerWidth > 768){
            setIsMobile(false);
        }
        let tempTitle='';
        let tempAboutUsRichText='';
        let tempCarouselItems =props.items.filter((item,idx)=>{
            if(item.MashanIsActive){
                if(!!item.MashanTopDesktopImage){
                    return true;
                }
                else{
                    //setAboutUsContentItem(item);
                    setAboutUsTitle(item.ContainerTitle);
                    setAboutUsRichText(item.RichTextContainer);

                    return false;
                }
            }
        });
        setAboutUsCarouselItems(tempCarouselItems);
    },[]);
  
    return <div className={'col-11 col-md-9 carousel-about-us-warpper nav-section'} id={`nav-section-0`}>
                <div className={'col-12  about-us-warpper-content'}>
                <div className={'col-12 col-xl-8 about-us-title'}>{aboutUsTitle}</div>
                <div className={'col-12 col-xl-11 about-us-rich-text'} dangerouslySetInnerHTML={{__html:aboutUsRichText}}></div>
               
                </div>
                <div className={'col-12 carousel-aboutus-items-warpper'}>
                    {/*col-md-12  {carouselItems} */}
                    <CarouselAboutUs items={aboutUsCarouselItems} />
                </div>
    </div>
};

export default AboutUsPage;